import { Fragment, useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
// import { useCookies } from 'react-cookie';

import Grid from "@mui/material/Grid";

import ActivateUserToken from "../ActivateUserToken";
import Login from "views/Login";
import RegisterAdmin from "views/RegisterAdmin";
import RegisterUser from "views/RegisterUser";
import PasswordReset from "views/PasswordReset";

import styles from "./Auth.css";
import logo from "assets/logo.png";

import AuthService from "services/http/AuthService";
const auth = new AuthService();

const Auth = (_props) => {
  // const [cookies, setCookie] = useCookies(['sessionid']);
  const classes = styles();

  useEffect(() => {
    // Remove existing token if exists
    auth.logout();
    // setCookie('sessionid', 'a', { path: '/' });
    //document.cookie = 'sessionid'+'=; Max-Age=-99999999;';
  }, []);

  return (
    <Fragment>
      <Grid
        container
        direction="row"
        className={classes.navContainer}
        sx={{ justifyContent: "center", alignItems: "center" }}
      >
        <Grid size={12}>
          <img src={logo} alt="logo" className={classes.logo} />
        </Grid>
      </Grid>

      <Grid
        container
        className={classes.introContainer}
        sx={{ alignContent: "center", alignItems: "center" }}
      >
        <Grid className={classes.introItem} size={{ xs: 12 }}>
          <Routes>
            <Route path="login" element={<Login />} />
            <Route path="register" element={<RegisterAdmin />} />
            <Route path="register/user" element={<RegisterUser />} />
            <Route path="reset/*" element={<PasswordReset />} />
            <Route path="activate/*" element={<ActivateUserToken />} />
            <Route path="*" element={<Navigate to="/auth/login" replace />} />
          </Routes>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Auth;
